import _ from 'underscore';
import { SERVICE_URL, I_AM_A_TEAPOT, BAD_SERVER, OKAY } from '@/store/_commons';
import getReCaptchaHeaderTBR from '@/utils/recaptchaTBR';
import axios from 'axios';
import LANG_EN from '@/assets/data/i18n/en'
import SYSTEM_FLOW from "@/assets/data/_steps"
import ROUTE_PAGES from '@/router/_pages'
import CUSTOMER_TYPES from '@/assets/data/_customerTypes'

// The store module will be an object exported directly.
export default {
  // CORRECT: `namespaced` is a top-level property of the module.
  namespaced: true,

  state: () => ({
    ALL_CUSTOMER_TYPES: CUSTOMER_TYPES,
    STEPS: SYSTEM_FLOW,
    STATUSES: {
        SERVER_ERR: BAD_SERVER,
        SUCCESS: OKAY,
        TEAPOT: I_AM_A_TEAPOT,
    },
    PAGES: ROUTE_PAGES,
    LANG: LANG_EN,                  // default to English
    modifyReservation: '',
    isLoading: false,
    availableSlotsByVisitType: [],  // slots from backend after category/type selection
    networkResponse: { status: OKAY, message: '' },
    resAvailableSlots: [],          // slots after being filtered
    resCurrentDays: [],             // slots by days (# of days varied) for display
    resIsLastPage: false,
    resSlottedWeeks: [],

    // in session storage
    resCategory: -1,
    resType: -1,
    resTypeForCustomer:             // include new AllowedCustomerTypeId from SOAP to identify Individual vs. Buz services
        { allowedCustomerTypeId: -1, isFeeApplicable: false, visitTypeId: -1 }, // TODO: replace resType and resFeeApplicable
    resFeeApplicable: false,        // tied to resType but backend will return the separate isFeeApplicable prop
    resSlot: -1,
    reservationSlotId: -1,
    reservationUserId: '',
    resSlotHoldEndTime: -1,
    resDetails: {},
    resAppointmentNum: '',          // reservation response prop 1
    resAppointmentBarcode: '',      // reservation response prop 2
    resAppointmentLocation: {},     // reservation response prop 3
    resNotificationSent: {},        // reservation response prop 4 (reservationSendConfirmationResponse)
    resLookup: {},
    resSelectedForUpdate: {},
    showModalAlert: false,
    modalDetails: {},
    onlineToken: '',
    ocaCustomerType: '',             // OCA customer type — only populated when arriving via "Make a new Reservation" link

    reservationsFound: [],

    nextRouteFunction: null,

    resSubStep: 0,
    newResSnapshot: null,             // snapshot of the new-reservation state before ReservationList can overwrite it
  }),

  mutations: {
    
    setState(state, { property, value }) {
      state[property] = value;
    },

    setReservationDetails(state, payload) {
      state.resDetails = payload;
    },
    
    resetState(state, allProps = false) {
      const type = state.resDetails.serviceType;
      const defaultState = {
        resAppointmentBarcode: '',
        resAppointmentNum: '',
        resAppointmentLocation: {},
        resNotificationSent: {},
        resLookup: {},
        resDetails: {
          serviceDate: '', serviceLocation: {}, serviceTime: '', serviceType: type, userInfo: {},
          internalServiceTime: ''
        },
        resSlotHoldEndTime: -1,
        reservationSlotId: -1,
        reservationUserId: '',
        resSlot: -1,
        modifyReservation: '',
        reservationsFound : [],
        resSubStep: 0,
        resSubOption: null,
      };

      Object.assign(state, defaultState);
      state.newResSnapshot = null;

      if (allProps) {
        state.resCategory = -1;
        state.resType = -1;
        state.resTypeForCustomer = { allowedCustomerTypeId: -1, isFeeApplicable: false, visitTypeId: -1 };
        state.resFeeApplicable = false;
        state.ocaCustomerType = '';
      }
      state.resSelectedForUpdate = {};
    },

    setReservationsFound(state, payload) {
      state.reservationsFound = payload;
    },

    setNextRouteFunction(state, next) {
      state.nextRouteFunction = next;
    },
  },

  actions: {
    async sendConfirmation(context, data) {
      const endpoint = `${SERVICE_URL}reservation/confirm`;
      const config = await getReCaptchaHeaderTBR('post', endpoint);

      let response = undefined;
      try {
        response = await axios.post(endpoint, data, config);
      } catch (error) {
        console.error(error);
      }
      return response ? response.data : I_AM_A_TEAPOT;
    },

    isReservationForUpdate({ state }) {
      return (state.resSelectedForUpdate?.visitTypeId ?? 0) > 0;
    },

    async resetReservationDetails({ commit }, allProps = false) {
      commit('resetState', allProps);
    },

    async setReservationDetails({ commit, state }, data) {
      const details = { ...state.resDetails };

      _.each(data, item => {
        details[item.property] = item.value;
      });
      // Commit the change
      commit('setState', { property: 'resDetails', value: details });
    },

    setStoreProperty({ commit }, data) {
      commit('setState', { property: data.property, value: data.value });
    },

    setTransitionalNetworkStatus({ commit }) {
      commit('setState', { property: 'networkResponse', value: { status: I_AM_A_TEAPOT, message: '' } });
    }
  },
};